<template>
  <div class="content">
    <el-select v-model="queryParams.userId" filterable placeholder="代理商" @change="agentsearch" clearable>
      <el-option v-for="(item,index) in agent" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId">
      </el-option>
    </el-select>
    <el-select v-model="queryParams.targetUserId" filterable placeholder="下级代理商" @change="search" clearable v-if="adminShow">
      <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId">
      </el-option>
    </el-select>
    <el-input v-model="queryParams.missionId" clearable placeholder="业务号" @keyup.enter.native="search"></el-input>
    <el-date-picker
      style="margin-right:30px"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      v-model="searchTime"
      @change="search"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
    ></el-date-picker>
    <el-checkbox v-model="queryParams.currentUser" style="margin-right: 30px" v-if="adminShow" @change="search">管理员记录</el-checkbox>
    <el-button type="primary" icon="el-icon-search" @click="search" class="button-class">搜索</el-button>
    <el-button type="primary" icon="el-icon-refresh" @click="handleCls" class="button-class">重置</el-button>
    <el-button type="primary" icon="el-icon-download" @click="handleExport" class="button-class">导出</el-button>
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border @sort-change="tableSortChange" max-height="600">
        <el-table-column prop="missionId" label="业务号" align="center" width="200px"></el-table-column>
        <el-table-column prop="companyName" label="代理商" align="center" width="180px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="targetCompanyName" label="分配代理商" align="center" width="180px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="transferDate" label="订单创建时间" align="center" width="120px"></el-table-column>
        <el-table-column prop="transferCard" label="订单卡数量" align="center"></el-table-column>
        <el-table-column prop="successCard" label="实际划拨数量" align="center"></el-table-column>
        <el-table-column prop="actualActivation" label="激活卡数" align="center" sortable="custom"></el-table-column>
        <el-table-column prop="firstCharge" label="首充卡数" align="center"></el-table-column>
        <el-table-column prop="firstRate" label="首充率" align="center"></el-table-column>
        <el-table-column prop="againRate" label="复充率" align="center" sortable="custom">
          <template slot-scope="{row}">
            <span>{{row.againRate + '%'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="editRow(scope.row.id)" style="background:#24D2B5;border: 1px solid #24D2B5;">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { agentList } from "@/api/api.js"; //初始化代理商
import { rechargeList } from "@/api/api.js"; //获取列表
import { exportListRecharge } from "@/api/api.js"; //导出
import { agentChildList } from "@/api/api.js"; 
export default {
  data() {
    return {
      queryParams:{
        currentUser:false
      },
      agent:[],
      agentList:[],
      searchTime:'',
      tableData:[],
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      page: 1,
      pageSize: 20,
      total: 0,
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
    
  },
  methods: {
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        if (res.data.code == 200) {
          this.agent = res.data.data;
          this.agentList = res.data.data;
        }
      });
    },
    agentsearch(){
      let params ={
        userId:this.queryParams.userId
      }
      agentChildList(params).then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data
        }
      })
    },
    // 导出
    handleExport(){
      let {currentUser} = this.queryParams;
      let params = {
        model:{
          ...this.queryParams,
          currentUser:currentUser ? 1:0
        },
      };
      // 搜索日期
      if (this.searchTime && this.searchTime[0]) {
        params.model.startTime = this.searchTime[0];
        params.model.endTime = this.searchTime[1];
      }
      exportListRecharge(params).then(res => {
        if (res.data.code == 200) {
          this.$notify({
            title: "提示",
            message: "已提交导出，请在任务中心查看进度",
            type: "success",
            offset:30
          });
          setTimeout(()=>{
            this.$router.push({ path: `/taskCenter/missionList`});
          },1000)
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      this.sortName = val.prop === "againRate" ? "againRate" : "actualActivation"
      this.initData()
    },
    // 获取数据
    initData() {
      let {currentUser} = this.queryParams;
      let params = {
        model:{
          ...this.queryParams,
          currentUser:currentUser ? 1:0,
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      // 搜索日期
      if (this.searchTime && this.searchTime[0]) {
        params.model.startTime = this.searchTime[0];
        params.model.endTime = this.searchTime[1];
      }
      rechargeList(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map(item=>{
            item.transferDate = item.transferDate.substr(0,10)
          })
        }
      })
    },
    // 搜索
    search(){
      this.initData();
    },
    // 详情
    editRow(id){
      this.$router.push({ path: `/taskCenter/toShowOrderNoDetail?id=${id}` });
    },
    // 重置
    handleCls(){
      for (var k in this.queryParams) {
        this.queryParams[k] = null;
      }
      this.page = 1;
      this.pageSize = 20;
      this.searchTime = [];
      this.queryAgentList();
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  mounted() {
    this.queryAgentList();
    this.initData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
 	.el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .button-class{
    border-radius: 3px;
    padding: 10px 20px;
  }
</style>





















